import { render, staticRenderFns } from "./FilteredItemsDropdown.vue?vue&type=template&id=19caacf9&scoped=true&"
import script from "./FilteredItemsDropdown.vue?vue&type=script&lang=js&"
export * from "./FilteredItemsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FilteredItemsDropdown.vue?vue&type=style&index=0&id=19caacf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19caacf9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19caacf9')) {
      api.createRecord('19caacf9', component.options)
    } else {
      api.reload('19caacf9', component.options)
    }
    module.hot.accept("./FilteredItemsDropdown.vue?vue&type=template&id=19caacf9&scoped=true&", function () {
      api.rerender('19caacf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/components/FilteredItemsDropdown.vue"
export default component.exports